<template>
    <transition name="modal">
        <div
            :class="[{'modal-mask-absolute': isAbsolute}, 'modal-mask']"
        >
            <div class="modal-wrapper">
                <div
                    v-click-outside="outsideModal"
                    class="modal-container"
                    :style="containerStyle"
                >
                    <div
                        v-if="showHeader"
                        class="modal-header"
                    >
                        <slot name="header"></slot>
                    </div>
                    <div class="modal-body">
                      <core-icon
                        v-if="!enableClickOutside"
                        @click.native="closeModal"
                        class="pointer d-block ml-auto"
                        iconName="Close"
                        iconColor="#bdbdbd"
                      >
                        <icons-close></icons-close>
                      </core-icon>
                      <slot name="body"></slot>
                    </div>
                    <div
                        v-if="showFooter"
                        class="modal-footer"
                    >
                        <slot name="footer">
                            <button class="modal-default-button" @click="$emit('close')">
                                OK
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { clickOutside } from '@/mixins/clickOutside'
export default {
  props: {
    isAbsolute: {
      default: false,
      type: Boolean,
      required: false
    },
    containerStyle: {
      default: null,
      type: String,
      required: false
    },
    showFooter: {
      default: true,
      type: Boolean,
      required: false
    },
    showHeader: {
      default: true,
      type: Boolean,
      required: false
    },
    stateOpen: {
      default: false,
      type: Boolean,
      required: false
    },
    enableClickOutside: {
      default: true,
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      isShown: this.stateOpen,
      counter: 0
    }
  },
  mixins: [clickOutside],
  methods: {
    outsideModal () {
      // workaround for date-picker - causing click outside directive to be triggered when date selected
      if (!this.enableClickOutside) {
        return
      }
      // First click that opened the modal, should not close the modal
      if (this.counter === 1) {
        this.counter = 0
        this.isShown = false
        this.$emit('close')
      }

      if (this.isShown) {
        this.counter += 1
      }
    },
    closeModal () {
      this.counter = 0
      this.isShown = false
      this.$emit('close')
    }
  }
}
</script>

<style>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-mask-absolute {
        position: absolute;
        z-index: 9998;
        left: 0;
        width: 100%;
        height: 100%;
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        min-width: 380px;
        margin: 0 auto;
        padding: 5px;
        background-color: #fff;
        border-radius: 5px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
    }

    .modal-header {
        border-bottom: 0;
        padding: 0;
    }

    .modal-header h4 {
        margin-top: 0;
        color: #008CDD;
    }

    .modal-default-button {
        float: right;
    }

    .modal-footer {
      border-top: 0;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>



// WEBPACK FOOTER //
// src/components/core/Modal.vue